'use client';

import { getLocale } from '@libs/core';

import { HeaderMini } from '../HeaderMini';
import GlobalErrorBody from './GlobalErrorBody';
import type { GlobalErrorProps } from './types';

// Used in src/app/global-error.tsx
export default function GlobalErrorPage({ reset, error }: GlobalErrorProps) {
    const currentLocale = getLocale();
    return (
        <html lang={currentLocale}>
            <head>
                <title>Global Error Page</title>
            </head>
            <body>
                <HeaderMini />
                <GlobalErrorBody reset={reset} error={error} />
            </body>
        </html>
    );
}
